import $ from 'jquery';
import run from '../../utilities/run';
import { handleDisplayFor, setElementsFromScope, hide, show } from "../../utilities/selectorHelpers";
require("../stubs/amazonLPNInfo/amazonLPNInfo.less");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
const targetSelector = "#amazon-fba-shipment-carton-info";

run(targetSelector, (mainEl) => {
	amazonShipmentInfo(mainEl);
});

function amazonShipmentInfo(mainEl) {
	//modals
	let supervisorModal;
	const errorFlow = new SubmitModalFlow;
	const elsPage = {};
	errorFlow.init();

	const elementsPageMap = {
		approveOverrideBtn: ".approve-override-btn",
		sendCartonMismatch: "#send-carton-mismatch-msg",
		noProblemsMessageSection: "#no-problems-msg-section",
		sendCartonToAmazon: "#send-carton-to-amazon",
		quantityAllMatchBadge: "#qty-all-match-badge",
		resendCartonToAmazon: "#resend-carton-to-amazon",
		loadingScreenMask: "#loading-screen-mask",
		feedSubmissionId: "#feedSubmissionId",
		connectionTimeoutMsg: "#connection-timeout-message",
		approveOverrideSubmitBtn: "#approve-override-submit-btn",
		invalidCredentialsMsg: "#invalid-credentials-message",
		noPermissionOverrideMsg: "#no-permission-override-message",
		overrideLoginUser: "#overrideLoginUser",
		overrideLoginPwd: "#overrideLoginPwd",
		misMatchErrorMsg: "#mismatch-error-msg",
		quantityMisMatchBadge: "#qty-mismatch-badge",
		overrideSuccessMsg: "#overide-success-msg",
		sendCartonErrorResponse: "#send-carton-error-response",
		qpillRed: ".q-pill-red"
	}

	// Modal Options/Creation
	const modalOpts = { backdrop: 'static', show: false };

	function init() {
		setElements();
		bindElements();
		//miscSetup();
	}

	/*function miscSetup() {
		facilityModal.modal(modalOpts);
	} */

	function bindElements() {

		//approverBtn clicked
		elsPage.approveOverrideBtn.on("click", function (e) {
			e.preventDefault();
			showSupervisorModal();
		});

		//first function
		elsPage.sendCartonToAmazon.on("click", function (e) {
			e.preventDefault();
			sendCartonToAmazonFlow();
		});

		//last function
		elsPage.approveOverrideSubmitBtn.on("click", function (e) {
			e.preventDefault();
			approveOverrideSubmitFlow();
		});
	}

	function setElements() {
		setElementsFromScope(elsPage, elementsPageMap, mainEl);
		elsPage.overrideSuccessMsg.hide(); //hide override success msg on page load
	}

	//modal show
	function showSupervisorModal() {
		supervisorModal.modal("show");
	}

	//on page load
	/*if ((elsPage.sendCartonMismatch).length > 0) {
		elsPage.noProblemsMessageSection.hide();
		elsPage.sendCartonToAmazon.hide();
		elsPage.quantityAllMatchBadge.hide();
	} */

	//first function
	function sendCartonToAmazonFlow() {
		elsPage.loadingScreenMask.removeClass('hide');

		//doubt on this snippet of code
		if (!(elsPage.resendCartonToAmazon.hasClass("hide"))) {
			elsPage.resendCartonToAmazon.addClass('hide');
		}

		$('#send-carton-to-amazon').hide();
		$.ajax({
			url: mainEl.data("send-carton-url"),
			type: 'POST',
			dataType: 'JSON',
			data: {
				palletNumber: mainEl.data("pallet-number"),
				orderId: mainEl.data("order-id"),
				shipmentId: mainEl.data("shipment-id"),
				shippingType: mainEl.data("shipping-type"),
				doNumber: mainEl.data("do-number"),
				feedSubmissionId: elsPage.feedSubmissionId.val(),
				override: false
			},
			success: function (response) {
				elsPage.loadingScreenMask.addClass('hide');
				elsPage.feedSubmissionId.val(response.feedSubmissionId);
				if (response.status == 'success') {
					window.location = mainEl.data("scan-lpn-url");
				} else if (response.status == 'ERROR') {
					elsPage.noProblemsMessageSection.hide();
					elsPage.connectionTimeoutMsg.removeClass('hide');
					$("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
					elsPage.resendCartonToAmazon.removeClass('hide');
				} else {
					elsPage.noProblemsMessageSection.hide();
					elsPage.sendCartonErrorResponse.removeClass('hide');
					elsPage.connectionTimeoutMsg.addClass('hide');
					$("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
					elsPage.resendCartonToAmazon.removeClass('hide');
				}
			},
			error: function () {
				elsPage.noProblemsMessageSection.hide();
				elsPage.loadingScreenMask.addClass('hide');
				elsPage.sendCartonErrorResponse.removeClass('hide');
				$("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
				elsPage.resendCartonToAmazon.removeClass('hide');
			}
		});
	}


	$('#resend-carton-to-amazon a').click(function (e) {
		e.preventDefault();
		$('#send-carton-to-amazon a').trigger('click');
	});

	//last function
	function approveOverrideSubmitFlow() {
		elsPage.invalidCredentialsMsg.addClass('hide');
		elsPage.noPermissionOverrideMsg.addClass('hide');
		$.ajax({
			url: mainEl.data("approve-override-url"),
			type: 'POST',
			dataType: 'html',
			data: {
				palletNumber: mainEl.data("pallet-number"),
				orderId: mainEl.data("order-id"),
				overrideLoginUser: elsPage.overrideLoginUser.val(),
				overrideLoginPwd: elsPage.overrideLoginPwd.val()
			},
			success: function (data) {
				if (data == 'success') {
					//modal.modal("hide");
					supervisorModal.modal("hide");
					elsPage.misMatchErrorMsg.hide();
					elsPage.approveOverrideBtn.hide();
					elsPage.sendCartonMismatch.hide();
					elsPage.quantityMisMatchBadge.hide();
					elsPage.noProblemsMessageSection.show();
					elsPage.quantityAllMatchBadge.show();
					elsPage.overrideSuccessMsg.show();
					elsPage.sendCartonToAmazon.show();
					elsPage.qpillRed.each(function (i, obj) {
						$(this).removeClass();
					});
					override = true;
				} else if (data == 'Authentication failed') {
					elsPage.invalidCredentialsMsg.removeClass('hide');
				} else if (data == 'No supervisor role is assigned') {
					elsPage.noPermissionOverrideMsg.removeClass('hide');
				}
			},
			error: function () {
				errorFlow.showFailureModal();
			}
		});
	}

	//$('#resend-carton-to-amazon a').click(function(e){
	/*elsPage.resendCartonToAmazon.click(function(e){
		  e.preventDefault();
		  elsPage.sendCartonToAmazon.trigger('click');  
	}); */
	$('#resend-carton-to-amazon a').click(function(e){
		e.preventDefault();
		$('#send-carton-to-amazon a').trigger('click');  
	});
	init();

}


// WEBPACK FOOTER //
// ./src/pages/amazon-fba-order/amazonShipmentInfo.js